import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitActivationDialogExtensionInterface } from '../../../extension/interface/benefit-activation-dialog.extension.interface';
import { BenefitColumnsExtensionInterface } from '../../../extension/interface/benefit-columns.extension.interface';
import { BenefitInfoTextExtensionInterface } from '../../../extension/interface/benefit-info-text.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { BenefitNavigationExtensionInterface } from '../../../extension/interface/benefit-navigation.extension.interface';
import { InternetBenefitActivationDialogExtension } from './extension/internet-benefit-activation-dialog.extension';
import { InternetBenefitColumnsExtension } from './extension/internet-benefit-columns.extension';
import { InternetBenefitInfoTextExtension } from './extension/internet-benefit-info-text.extension';
import { InternetBenefitMetadataExtension } from './extension/internet-benefit-metadata.extension';
import { InternetBenefitNavigationExtension } from './extension/internet-benefit-navigation.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('internet')
    .add(BenefitMetadataExtensionInterface, new InternetBenefitMetadataExtension())
    .add(BenefitNavigationExtensionInterface, new InternetBenefitNavigationExtension())
    .add(BenefitColumnsExtensionInterface, new InternetBenefitColumnsExtension())
    .add(BenefitActivationDialogExtensionInterface, new InternetBenefitActivationDialogExtension())
    .add(BenefitInfoTextExtensionInterface, new InternetBenefitInfoTextExtension())
    .build(),
);
